import { Col, Row, Select, Tabs } from "antd";
import { useState } from "react";
import { FaLinkedinIn } from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import Layout from "../../Components/Layout/Layout";
import AlphaSlider from "../../Components/Sliders/AlphaSlider/AlphaSlider";
import styles from "./OurStory.module.scss";
import { coreValuesData } from "./data";
import ali from "./images/abas.png";
import about_banner_desk from "./images/about_banner_desk.svg";
import core_v_active from "./images/core_value_active.svg";
import core_v_inactive from "./images/core_value_inactive.svg";
import mission from "./images/mission.svg";
import mission_vision_active from "./images/mission_vision_active.svg";
import mission_vision_inactive from "./images/mission_vision_inactive.svg";
import our_story_active from "./images/our_story_active.svg";
import our_story_inactive from "./images/our_story_inactive.svg";
import our_team_active from "./images/our_team_active.svg";
import our_team_inactive from "./images/our_team_inactive.svg";
import preeti from "./images/preeti.png";
import ret_ref_img from "./images/ret_ref_img.svg";
import story_slider_1 from "./images/story_slider_1.png";
import story_slider_2 from "./images/story_slider_2.png";
import story_slider_3 from "./images/story_slider_3.png";
import vision from "./images/vision.svg";

const OurStory = () => {
    const slider_1 = [
        {
            img: story_slider_1,
            url: "/our-story",
        },
        {
            img: story_slider_2,
            url: "/our-story",
        },
        {
            img: story_slider_3,
            url: "/our-story",
        },
    ];

    const dt_slides = [
        {
            img: about_banner_desk,
            url: "/our-story",
        },
        {
            img: about_banner_desk,
            url: "/our-story",
        },
        {
            img: about_banner_desk,
            url: "/our-story",
        },
    ];

    const [activeKey, setActiveKey] = useState("1");

    return (
        <Layout title="Our Story">
            {/*Alpha Slider 1*/}
            <div className="px-3 px-sm-0 mt-0 mt-sm-4">
                <AlphaSlider slides={slider_1} dt_slides={dt_slides} />
            </div>

            <div className={styles.wrapper}>
                <div className="custom_story_tab">
                    <Tabs
                        defaultActiveKey="1"
                        tabPosition="top"
                        animated={{
                            inkBar: true,
                            tabPane: true,
                        }}
                        onChange={(activeKey) => {
                            setActiveKey(activeKey);
                        }}
                        items={[
                            {
                                key: "1",
                                label: (
                                    <div className={styles.tab_header}>
                                        <img src={activeKey === "1" ? our_story_active : our_story_inactive} alt="our_story" />
                                        <span className="fs-3">Our Story</span>
                                    </div>
                                ),
                                children: <OurStoryTab />,
                            },
                            {
                                key: "2",
                                label: (
                                    <div className={styles.tab_header}>
                                        <img
                                            src={activeKey === "2" ? mission_vision_active : mission_vision_inactive}
                                            alt="mission_vision"
                                        />
                                        <span className="fs-3">Mission & Vision</span>
                                    </div>
                                ),
                                children: <MissionVision />,
                            },
                            {
                                key: "3",
                                label: (
                                    <div className={styles.tab_header}>
                                        <img src={activeKey === "3" ? core_v_active : core_v_inactive} alt="core_v" />
                                        <span className="fs-3">Core Values</span>
                                    </div>
                                ),
                                children: <CoreValues />,
                            },
                            {
                                key: "4",
                                label: (
                                    <div className={styles.tab_header}>
                                        <img src={activeKey === "4" ? our_team_active : our_team_inactive} alt="our_team" />
                                        <span className="fs-3">Our Team</span>
                                    </div>
                                ),
                                children: <OurTeam />,
                            },
                        ]}
                    />
                </div>
            </div>
        </Layout>
    );
};

export default OurStory;

const OurStoryTab = () => {
    // const [modalVisible, setModalVisible] = useState(false);
    // function showModal() {
    //     setModalVisible(true);
    // }

    // function hideModal() {
    //     setModalVisible(false);
    // }

    return (
        <div className={styles.os}>
            <h3 className={styles.os_title}>Our Story</h3>
            <h4 className={styles.os_subtitle}>Experience Fresh Authenticity with Desi</h4>
            <p className={styles.os_para}>
                The birth of Desi Fresh is a story of two individuals who sought to solve a common problem faced by Desi communities –
                finding high-quality, authentic groceries with a focus on{" "}
                <strong>food safety, quality, hygiene, reliable delivery, and customer support</strong> . Dr. Preeti and Dr. Ali Abas Wani
                were two food industry professionals with over 40 years of combined experience, who saw a need for a solution that met the
                needs of their community.
            </p>
            <p className={styles.os_para}>
                With their extensive experience in food safety, quality, hygiene and collective approach to{" "}
                <strong>sustainability and social responsibility</strong> , Desi Fresh sources products directly from India, Pakistan,
                Bangladesh, and Sri lanka, ensuring the highest standards of quality and authenticity. Our quality assurance team is
                relentless in their pursuit of excellence, only allowing products that meet our strict standards to make it to your
                doorstep.
            </p>

            <div>
                <img
                    src={ret_ref_img}
                    alt="ret_ref_img"
                    className={styles.ret_ins_img}
                    // onClick={showModal}
                />
                {/* do not delete this comment */}
                {/* <VideoModal visible={modalVisible} onCancel={hideModal} /> */}
            </div>

            <div className={styles.language_sel}>
                <Select
                    defaultValue="en"
                    style={{ width: 120, marginBottom: 20 }}
                    options={[
                        { label: "English", value: "en" },
                        { label: "German", value: "de" },
                    ]}
                />
            </div>

            <p className={styles.os_para}>
                At Desi Fresh, our mission goes beyond simply providing authentic groceries and products. We believe in creating a community
                of individuals who not only enjoy the taste of home but also make a difference in the lives of others. With every purchase,
                you become part of <strong>our mission to support underprivileged children </strong>
                with <strong>education, food, and healthcare</strong> . Your love for authentic flavors doesn't just satisfy your taste
                buds, it has a ripple effect of kindness and generosity.
            </p>
            <p className={styles.os_para}>
                Our sustainability initiatives aim to reduce carbon footprint and to protect the planet. From sourcing ethically and
                reducing food waste, to investing in eco-friendly packaging and energy-efficient facilities, Desi Fresh is dedicated to
                making a positive impact on the environment. The company also supports fair trade practices and works with suppliers who
                share their values of sustainability and social responsibility. With Desi Fresh, customers can now enjoy delicious,
                authentic groceries while supporting a sustainable future.
            </p>
            <p className={styles.os_para}>
                At Desi Fresh, we're committed to providing you with the freshest groceries and the best shopping experience, all while
                keeping the Desi wheel moving. Join us on our journey and discover a better way to shop for your favorite authentic and
                high-quality products.
            </p>
        </div>
    );
};

const MissionVision = () => {
    return (
        <div className={styles.mv}>
            <h3 className={styles.mv_title}>Mission & Vision</h3>
            <div className={styles.mission}>
                <img src={mission} alt="mission" />
                <div className="d-flex flex-column justify-content-center align-items-center gap-2 align-items-sm-start">
                    <h4>Mission</h4>
                    <p className={styles.mv_para}>
                        Our mission is to deliver convenience and authenticity hand in hand. We strive to provide an effortless shopping
                        experience for high-quality and authentic products that elevate the Desi way of life.
                    </p>
                </div>
            </div>
            <div className="mt-0 mt-sm-5"></div>
            <div className={styles.vision}>
                <img src={vision} alt="mission" />
                <div className="d-flex flex-column justify-content-center align-items-center gap-2 align-items-sm-start">
                    <h4>Vision</h4>
                    <p className={styles.mv_para}>
                        Desi Fresh's vision is to be a leader in providing authentic and high-quality products while giving back to the
                        community. We strive to be the go-to provider for Desi communities globally, creating a cultural hub that brings
                        people together through food, tradition, and community. Our commitment to excellence in quality, customer service,
                        and sustainability, along with our dedication to making a positive impact, make us a trusted household name that
                        enriches lives and creates memories.
                    </p>
                </div>
            </div>
        </div>
    );
};

const CoreValues = () => {
    return (
        <div className={styles.cv}>
            <h3 className={styles.cv_title}>Core Values</h3>
            <div className={styles.cv_subtitle}>
                At Desi Fresh, we are guided by these principles that shape our decision-making, our culture, and our relationships with
                stakeholders.
            </div>
            <br />
            <Row gutter={[30, 30]}>
                {coreValuesData.map((item, index) => (
                    <Col xs={24} sm={12} md={8} lg={8} key={index}>
                        <div className={styles.cv_card}>
                            <img src={item.image} alt="cv_card" />
                            <h4 className="fs-3">{item.title}</h4>
                            <p className="fs-3">{item.description}</p>
                        </div>
                    </Col>
                ))}
            </Row>
            <br />
        </div>
    );
};

const OurTeam = () => {
    return (
        <div className={styles.team}>
            <h3 className={styles.team_title}>Our Founders</h3>
            <div className={styles.p_s}>
                <div className="d-flex flex-column align-items-center justify-content-center align-items-sm-start">
                    <img src={preeti} alt="preeti" />
                    <div>
                        {" "}
                        <strong>Dr. Preeti Singh,</strong> Ph.D
                    </div>
                    <div style={{ marginBottom: 5 }}>Founder & CEO</div>
                    <div className={styles.ps_social}>
                        <a href="https://www.linkedin.com/in/preeti-singh-0b0b4a1/">
                            <FaLinkedinIn size={20} />
                        </a>

                        <a href="mailto:">
                            <GrMail size={20} />
                        </a>
                    </div>
                </div>

                <div>
                    <div className={styles.bio_g}>Biography</div>

                    <p>
                        Meet Dr. Preeti, the visionary CEO behind Desi Fresh, the one-stop-shop for authentic, high-quality, and affordable
                        groceries. With a Ph.D. in Dairy Technology and extensive experience in the field of food technology, she has
                        established herself as a leading expert in food safety and quality control. She has worked at various prestigious
                        organizations, including the <a href="/">Defence Food Research Laboratory</a> in Mysore, India and the{" "}
                        <a href="/">Technical University of Munich</a> in Germany, where she honed her skills and acquired a deep
                        understanding of the food industry.
                    </p>
                    <p>
                        As a consultant to numerous companies, she has helped implement best practices in quality control, packaging,
                        hygiene, and more. She is also an editor for the Food Packaging, which promotes research on quality control and
                        better packaging practices. With her vast knowledge and expertise, Dr. Preeti has set high standards for food safety
                        and quality in the industry.
                    </p>
                    <p>
                        At Desi Fresh, her mission is to bring authentic, high-quality groceries to everyone, and to provide the best
                        possible customer experience. Her passion for food technology and her commitment to quality and safety have made her
                        a trusted leader in the industry. With her as CEO, Desi Fresh is set to make a significant impact on the food
                        industry and revolutionize the way people shop for groceries.
                    </p>
                    <p>
                        In addition to her professional accomplishments, she is a certified Lead Auditor for ISO 9001, BRC Food, FSSC 22000,
                        ISO22000, and HACCP level 4 standards, ensuring that Desi Fresh adheres to the highest standards in the industry.
                        Her unwavering commitment to excellence, integrity, and innovation make her a true leader and an inspiration to all
                        those who work with her.
                    </p>
                </div>
            </div>
            <br />
            <div className={styles.p_s}>
                <div className="d-flex flex-column align-items-center justify-content-center align-items-sm-start">
                    <img src={ali} alt="ali" />
                    <div>
                        <strong>Dr. Ali Abas Wani,</strong> Ph.D, MBA
                    </div>
                    <div style={{ marginBottom: 5 }}>Co- Founder & COO</div>
                    <div className={styles.ps_social}>
                        <a href="https://www.linkedin.com/in/aa">
                            <FaLinkedinIn size={20} />
                        </a>

                        <a href="mailto:">
                            <GrMail size={20} />
                        </a>
                    </div>
                </div>

                <div>
                    <div className={styles.bio_g}>Biography</div>

                    <p>
                        Dr. Ali Abas Wani is a visionary in the world of food, with a passion for improving people's lives through
                        innovative, healthy food options. He brings over 25 years of experience in the food industry to his role as
                        Co-Founder and COO of Desi Fresh, where he is a driving force behind the company's mission to make high-quality,
                        authentic food accessible to all.
                    </p>
                    <p>
                        With a Ph.D. in Food Technology and an Executive MBA from ESSEC & Mannheim Business Schools in France & Germany, he
                        is a highly knowledgeable and well-rounded professional. Before co-founding Desi Fresh, he served as a Professor at
                        an Indian University and Principal Scientist at the <a href="/">Fraunhofer Institute</a> for Process Engineering &
                        Packaging IVV in Germany.
                    </p>
                    <p>
                        In addition to his work with Desi Fresh, he is a respected expert in the field of food innovation, consumer health,
                        and food traceability, having served as a consultant to multiple companies. He is also the founder and
                        Editor-in-Chief of <a href="/">Food Packaging & Shelf Life</a> , which ranks among the top 10 journals in food
                        science. His commitment to advancing the field of food science is further demonstrated by his role as the regional
                        Chair for India European Hygienic Design Group <a href="/">(EHEDG)</a> . Through his work, he is dedicated to making
                        a positive impact on people's lives and the health of communities through the food they eat.
                    </p>
                    <p>
                        His vision for Desi Fresh is to bring authentic and high-quality products to consumers, while promoting health and
                        wellness through education and awareness.
                    </p>
                </div>
            </div>
        </div>
    );
};

//  WARNING: do not delete this commented code

// const VideoModal = ({ visible, onCancel }) => {
//     return (
//         <Modal open={visible} onCancel={onCancel} footer={null} destroyOnClose closable={null} bodyStyle={{ padding: 0 }} centered>
//             <div
//                 style={{
//                     position: "relative",
//                     paddingBottom: "56.25%" /* 16:9 */,
//                 }}
//             >
//                 <ReactPlayer
//                     style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                     }}
//                     url="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
//                     width="100%"
//                     height="100%"
//                     muted={true}
//                     playing={true}
//                     controls={true}
//                 />
//             </div>
//         </Modal>
//     );
// };
